module.exports = __webpack_public_path__ + "static/client_11_before-d104fface236816096599b42c51fb423.jpg";